import Swiper from 'swiper';

// init Swiper:
new Swiper('.link-with-image__carousel', {
  slidesPerView: 'auto',
  spaceBetween: 20,
  watchOverflow: true,
  direction: 'horizontal',
  navigation: {
    nextEl: '.link-with-image__carousel__navigation .swiper-button-next',
    prevEl: '.link-with-image__carousel__navigation .swiper-button-prev',
  },
  pagination: {
    el: '.link-with-image__carousel__navigation .swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    992: {
      slidesPerView: 4,
      spaceBetween: 20,
      direction: 'vertical',
    },
  },
});

const linksWithImageContainers = document.querySelectorAll(
  '.link-with-image__container'
);

linksWithImageContainers.forEach((linksWithImageContainer) => {
  const imageContainer =
    linksWithImageContainer.querySelector('.imageContainer');
  const linksWithImage = linksWithImageContainer.querySelectorAll(
    '.link-with-image__link-item'
  );

  linksWithImage.forEach((element) => {
    const elementImage = element.getAttribute('data-image');

    element.addEventListener('mouseover', function (event) {
      event.stopImmediatePropagation();
      imageContainer.style.setProperty(
        '--Background-url',
        'url(' + elementImage + ')'
      );
    });
  });
});
